import type { components } from '@/api/typeApi'

export type DefaultModalProp = {
  open: boolean
  setOpen: (state: boolean) => void
  onConfirm?: () => void
}

export type ModalFooterProps = {
  confirmButtonText?: string
  cancelButtonText?: string
  onConfirm?: () => void
  isLoading?: boolean
  type: ModalType
}

export type ModalComponentProps = {
  minHeight?: string
  modalFooter?: (props: ModalFooterProps) => JSX.Element
  modalBody?: JSX.Element
  modalHeader?: JSX.Element | string
} & DefaultModalProp &
  ModalFooterProps

// The single list of modal types: `ModalType` is derived from it, and the store
// iterates it to find which modal is open. A modal missing here never renders.
export const MODAL_TYPES = [
  'editServerName',
  'confirmServersWithoutPatch',
  'rebootNode',
  'applyClusterConfig',
  'deleteSubnet',
  'confirmClusterConfigChange',
] as const

export type ModalType = (typeof MODAL_TYPES)[number]

export interface ModalProps {
  editServerName: { serverId: string; serverName: string }
  confirmServersWithoutPatch: {
    servers: Array<{
      id: string
      name: string
      address?: string | null
      nodeAddresses?: string[]
    }>
  }
  rebootNode: { serverId: string }
  applyClusterConfig: { clusterId: string; clusterName: string }
  deleteSubnet: {
    subnetId: string
    subnetName: string
    cidr: string
    clusterName?: string | null
  }
  confirmClusterConfigChange: {
    clusterId: string
    clusterName: string
    body: components['schemas']['UpdateClusterRequest']
  }
}

export interface ModalCallbacks {
  editServerName: undefined
  confirmServersWithoutPatch: { onConfirm: () => void }
  rebootNode: undefined
  applyClusterConfig: undefined
  deleteSubnet: undefined
  // The modal renders outside the router, so leaving the page is the opener's.
  confirmClusterConfigChange: { onSuccess: () => void }
}
